import { useContext } from "react";

import { SalesPageV3Context } from "../context";

export const usePageConfiguration = () => {
  const context = useContext(SalesPageV3Context);

  if (!context) {
    throw new Error(
      "usePageConfiguration can only be used inside SalesV3Provider",
    );
  }

  return {
    pageConfiguration: context.pageConfiguration,
    setPageConfiguration: context.setPageConfiguration,
    statuses: context.pageConfiguration.statuses,
    attributionModel: context.pageConfiguration.attributionModel,
    attributionWindow: context.pageConfiguration.attributionWindow,
    accountingMode: context.pageConfiguration.accountingMode,
    timeGranularity: context.pageConfiguration.timeGranularity,
    dateRange: context.pageConfiguration.dateRange,
    dateRangeInterval: context.dateRangeInterval,
    compareDateRange: context.pageConfiguration.compareDateRange,
    breakdowns: context.pageConfiguration.breakdowns,
    filters: context.pageConfiguration.filters,
    granularity: context.pageConfiguration.granularity,
    searchQuery: context.pageConfiguration.searchQuery,
    flyoutId: context.pageConfiguration.flyoutId,
    flyoutTab: context.pageConfiguration.flyoutTab,
    sorting: context.pageConfiguration.sorting,
    sortingOrder: context.pageConfiguration.sortingOrder,
    metricFilters: context.pageConfiguration.metricFilters,
    activeTab: context.pageConfiguration.activeTab,
    setStatuses: context.setStatuses,
    setSorting: context.setSorting,
    setSortingOrder: context.setSortingOrder,
    setMetricFilters: context.setMetricFilters,
    setActiveTab: context.setActiveTab,
    setGranularity: context.setGranularity,
    setGranularityAndActiveTab: context.setGranularityAndActiveTab,
    setAttributionModel: context.setAttributionModel,
    setAttributionWindow: context.setAttributionWindow,
    setAccountingMode: context.setAccountingMode,
    setTimeGranularity: context.setTimeGranularity,
    setDateRange: context.setDateRange,
    setCompareDateRange: context.setCompareDateRange,
    setBreakdowns: context.setBreakdowns,
    setFilters: context.setFilters,
    setSearchQuery: context.setSearchQuery,
    setFlyoutId: context.setFlyoutId,
    setFlyoutTab: context.setFlyoutTab,
  };
};
